var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduction texture-bg-css"},[_c('Top'),_c('Storehouse')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }